<template>
  <div class="tw-flex tw-flex-col">
    <label class="empty:tw-hidden tw-mb-0 tw-text-[18px]" :for="id">
      <slot name="label" />
    </label>
    <textarea
      class="tw-w-full tw-p-[1em] tw-rounded-[20px] tw-border-none tw-text-[18px] tw-leading-[inherit] tw-text-inherit tw-bg-[var(--my-white-soft)] tw-outline-none tw-resize-none placeholder:tw-text-[var(--my-text-color)]"
      :rows="rows"
      :id="id"
      :placeholder="placeholder"
      v-model="localValue"
      :style="{ fontSize: fontSize ? `${fontSize}px` : '' }"
    />
  </div>
</template>

<script>
import { nanoid } from "nanoid";

export default {
  name: "my-textarea",

  data() {
    return {
      id: "",
    };
  },

  props: {
    value: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    },
    rows: {
      type: String,
      default: "4",
    },
    placeholder: {
      type: String,
      default: "",
    },
    fontSize: {
      type: String,
      default: "",
    },
  },

  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },

  mounted() {
    this.id = nanoid();
  },
};
</script>
